export default {
  TITLE: "Rapport des lectures de caisse",
  TOTAL_AMOUNT: "Montant total",
  TOTAL_TRANSACTIONS: "Total des transactions",
  AVERAGE_PER_TRANSACTION: "Moy. par transaction",
  TOTAL_READINGS: "Total des lectures",
  TOTALS_OVER_TIME: "Totaux dans le temps",
  PAYMENT_BREAKDOWN: "Ventilation par type de paiement",
  REGISTER_COMPARISON: "Comparaison des caisses",
  TRANSACTION_TRENDS: "Tendances des transactions",
};
